// extracted by mini-css-extract-plugin
export default {"modal":"market-change-warning-module__modal___luOsF","modal-footer":"market-change-warning-module__modal-footer___JEvty"};